import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineClock, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";
import useOpenToSelect from "../hooks/useOpenToSelect";
import useFacility from "../../../../utils/hooks/useFacility";
import HtmlTooltip from "@mui/material/Tooltip";
import EAButton from "../../shared/Buttons/EAButton";
import { IoArrowForward } from "react-icons/io5";
import ExercisesPlan from "../ExercisesPlan";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { useNavigate } from "react-router-dom";
import { FINALIZE_PAGE } from "../../../routes";
interface IProps {
  ticket: Ticket;
  getSelect: () => void;
}

const LimitedOpenPassDesktop: React.FC<IProps> = ({ ticket, getSelect }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [allowToJoin, setAllowToJoin] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const { addPossibilityToJoin } = useOpenToSelect();
  const facilityIds = useFacility();
  const { prolongPass } = useBasketManager();
    const navigate = useNavigate();
    const finalizeFunction = () => {
        setTimeout(() => {
          navigate(FINALIZE_PAGE);
        }, 600);
      
    };
  const newValidTo = new Date(ticket.validto);
  newValidTo.setDate(newValidTo.getDate() + 1);

  
  useEffect(() => {
    if (facilityIds === "1212" || facilityIds === "1243" || facilityIds === "1241") {
      setAllowToJoin(addPossibilityToJoin(ticket));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <React.Fragment>
      {(ticket.passtype === 0 || ticket.passtype === 4) && ticket.ticket === false && (
        <div className="purchased-assort">
          <div className="purchased-assort_left">
            <div className="purchased-assort_startIcon">
              <HiOutlineTicket className="myAccount-ticketLine_icon" />
            </div>

            <div className="purchased-assort_body">
              <h5>
                {ticket.name}
                {ticket.description.length > 10 && (
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <article
                          className="tooltip-description"
                          dangerouslySetInnerHTML={{ __html: ticket.description }}
                        ></article>
                      </React.Fragment>
                    }
                  >
                    <b>
                      <BiInfoCircle className="tooltip-icon" />
                    </b>
                  </HtmlTooltip>
                )}
              </h5>

              <span className="purchased-assort_body__details">
                <HiOutlineClock /> {t("wazny_od")}:{" "}
                <b>
                  {format(ticket.validfrom, "dd.MM.yyyy")}r. | {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}r.
                </b>
              </span>

              <div className="purchased-assort__entrances">
                <IoArrowForward />
                {t("pozostalo")}: {ticket.passtype === 0 ? <b>OPEN</b> : <b>{ticket.entrances}</b>} {t("wejsc")}
              </div>
            </div>
          </div>

          {ticket.extendAllowed && (
            <EAButton
              title={t("przedluz_karnet")}
              onClick={() => {
                prolongPass(ticket.assortIds, 1, newValidTo);
                finalizeFunction();
              }}
              variant="filled"
            />
          )}

          <div className="purchased-assort_action">
            {allowToJoin && ticket.passtype === 0 && (
              <EAButton
                title={t("pokaz_terminy")}
                onClick={() => setAssignedList(!open)}
                fullWidth
                variant="outlined"
              />
            )}
            <EAButton title={t("pokaz_kod_qr")} onClick={() => setOpen(!open)} fullWidth endIcon={<HiQrcode />} />
          </div>
        </div>
      )}
      {open && (
        <ModalComponent
          footer={false}
          open={open}
          leftType="exercise"
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <EAButton title={t("gotowe_schowaj")} onClick={() => setOpen(!open)} />
        </ModalComponent>
      )}

      {assignedList && (
        <ModalComponent
          footer={false}
          leftType="exercise"
          open={assignedList}
          closeModal={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          onAccept={() => setAssignedList(false)}
        >
          <React.Fragment>
            <ExercisesPlan ticket={ticket} getSelect={getSelect} />

            {/* <SelectPassBar ticket={ticket} /> */}

            {/* {ticket.exercises[0] && (
              <div>
                {ticket.exercises.map((exercise, index) => (
                  <div key={index}>
                    <SingleExercise exercise={exercise} getSelect={getSelect} />
                  </div>
                ))}
              </div>
            )} */}

            {/* {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />} */}
          </React.Fragment>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default LimitedOpenPassDesktop;
